export const DEFAULT_AI_AGENT_WIDTH = 420;

/**
 * 研究复盘图表全屏时，进宝「宽屏显示」目标宽度。
 * 比普通页宽屏更克制，为左侧 K 线预留足够空间。
 */
export const AI_AGENT_CHART_FULLSCREEN_WIDE_WIDTH = 600;
